<template>
<!-- :item-text="alpha2 !== undefined ? $t('country_' + alpha2) : ''" -->
  <v-autocomplete
    :label="$t('country')"
    :items="countries"
    v-model="data"
    item-text="code"
    item-value="code"
    :filter="countryFilter"
    :rules="[() => !required || !!data || $t('required_field')]"
    :required="required"
    :hide-details="hideDetails || !required">
    <!-- Selected item. -->
    <template slot="selection" slot-scope="data">
      <v-avatar tile size="32px" class="mr-2">
        <img :src="data.item.flag">
      </v-avatar>
      <span class="black--text">{{ $t("country_" + data.item.alpha2) }}</span>
    </template>
    <!-- Data items. -->
    <template slot="item" slot-scope="data">
      <v-avatar tile class="mr-2">
        <img :src="data.item.flag">
      </v-avatar>
      {{ $t("country_" + data.item.alpha2) }}
    </template>
  </v-autocomplete>
</template>

<script>
import * as utils from '../../utils'
import { COUNTRIES } from '../../utils/lookups'

export default {
  props: {
    country: {
      default: '',
      required: true
    },
    required: {
      type: Boolean,
      default: false
    },
    hideDetails: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      data: '',
      countries: []
    }
  },

  mounted () {
    COUNTRIES.forEach((value, key, map) => {
      this.countries.push({ code: key, name: value.name, alpha2: value.alpha2, flag: utils.getCountryFlagUrl(key) })
    })
  },

  watch: {
    country (value) {
      this.data = value
    },
    data (value) {
      this.$emit('update:country', value)
    }
  },

  methods: {
    countryFilter (item, queryText, itemText) {
      if (!itemText || !queryText || queryText === '' || item === null || item === undefined || item.name === '') {
        return true
      }
      const name = this.$t('country_' + item.alpha2)
      return name.toLowerCase().indexOf(queryText.toLowerCase()) > -1
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/components/CountrySelect.vue